import { LoginEntity } from "../../entities/ServicesEntities/LoginEntities/LoginEntity";
import { UpdateUserPasswordEntity } from "../../entities/ServicesEntities/LoginEntities/UpdateUserPasswordEntity";
import { VerificationEntity } from "../../entities/ServicesEntities/LoginEntities/VerificationEntity";
import { GetChargeAccountUserIdsEntity } from "../../entities/ServicesEntities/UserEntities/GetChargeAccountUserIdsEntity";
import { GetUsersIdsEntity } from "../../entities/ServicesEntities/UserEntities/GetUsersIdsEntity";
import { GetUsersMinimalIdentityDataEntity } from "../../entities/ServicesEntities/UserEntities/GetUsersMinimalIdentityDataEntity";
import { GetSelectedUserDataEntity } from "../../entities/ServicesEntities/UserEntities/GetSelectedUserDataEntity";
import { VerificationIsUserExistsInUserSitesEntity } from "../../entities/ServicesEntities/VerificationsEntities/VerificationIsUserExistsInUserSitesEntity";
import { VerificationNewParkerSitesEntity } from "../../entities/ServicesEntities/VerificationsEntities/VerificationNewParkerSitesEntity";
import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";
import { SCOPE_TYPE } from "../../enums/Enums";

// AUTHENTICATE CONTROLLER FUNCTIONS
export const authenticate = (userIdentityId, refreshToken) => {
  return new Promise((resolve, reject) => {
    var queryParams =
      "?userIdentityId=" + userIdentityId + "&refreshToken=" + refreshToken;

    axiosActions
      .GET(SERVER_ROUTES.AUTHENTICATION, queryParams)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - authenticate()",
          error
        );
        reject(error);
      });
  });
};

// GMT LOGIN CONTROLLER FUNCTIONS
export const login = (userName, password, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var loginEntity = new LoginEntity(userName, password);
    var requestBody = loginEntity;

    axiosActions
      .POST(SERVER_ROUTES.LOGIN, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - login()", error);
        reject(error);
      });
  });
};
export const forgetPassword = (email) => {
  return new Promise((resolve, reject) => {
    axiosActions
      .POST(SERVER_ROUTES.FORGET_PASSWORD + email)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - forgetPassword()",
          error
        );
        reject(error);
      });
  });
};

export const resetPassword = (userId, newPassword) => {
  return new Promise((resolve, reject) => {
    var updateUserPasswordEntity = new UpdateUserPasswordEntity(
      userId,
      newPassword,
      "",
      false
    );
    var requestBody = updateUserPasswordEntity;

    axiosActions
      .POST(SERVER_ROUTES.RESET_PASSWORD, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - forgetPassword()",
          error
        );
        reject(error);
      });
  });
};

export const updatePassword = (userId, newPassword,oldPassword) => {
  return new Promise((resolve, reject) => {
    var updateUserPasswordEntity = new UpdateUserPasswordEntity(
      userId,
      newPassword,
      oldPassword,
      true
    );
    var requestBody = updateUserPasswordEntity;

    axiosActions
      .POST(SERVER_ROUTES.RESET_PASSWORD, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - forgetPassword()",
          error
        );
        reject(error);
      });
  });
};

export const unsubscribeUserByContent = (content) => {
  return new Promise((resolve, reject) => {
    var requestBody = new VerificationEntity(
      content
    );
    axiosActions
      .POST(SERVER_ROUTES.UNSUBSCRIBE, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - unsubscribeUserByContent()",
          error
        );
        reject(error);
      });
  });
};

export const validateResetPasswordContent = (content) => {
  return new Promise((resolve, reject) => {
    var requestBody = new VerificationEntity(
      content
    );
    axiosActions
      .POST(SERVER_ROUTES.VALIDATE_RESET_PASSWORD, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - validateResetPasswordContent()",
          error
        );
        reject(error);
      });
  });
};

export const validateSignUpContent = (content) => {
  return new Promise((resolve, reject) => {
    var requestBody = new VerificationEntity(
      content
    );
    axiosActions
      .POST(SERVER_ROUTES.VALIDATE_SIGNUP_CONTENT, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - validateSignUpContent()",
          error
        );
        reject(error);
      });
  });
};

export const getRegions = (isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = "";

    axiosActions
      .GET(SERVER_ROUTES.REGION, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getRegions()",
          error
        );
        reject(error);
      });
  });
};

export const getAllScopes = (isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = "";

    axiosActions
      .GET(SERVER_ROUTES.SCOPE, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getAllScopes()",
          error
        );
        reject(error);
      });
  });
};

// GMT INITIAL_STATE CONTROLLER FUNCTIONS
export const getInitialState = (userId, scopeId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = '?userId=' + userId + '&scopeId=' + scopeId;

    axiosActions
      .GET(SERVER_ROUTES.GET_INITIAL_STATE, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getInitialState()",
          error
        );
        reject(error);
      });
  });
};

// GMT GET USER SITES
export const getUserSites = (isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = "";

    axiosActions
      .GET(SERVER_ROUTES.SITE, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getUserSites()",
          error
        );
        reject(error);
      });
  });
};


// GET USER SCOPES
export const getUserScopes = (userId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = userId;

    axiosActions
      .GET(SERVER_ROUTES.SCOPE_BY_USER, queryParams, isShowSpinner,  closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getUserScopes()",
          error
        );
        reject(error);
      });
  });
};

// GET SCOPE BY SCOPE ID
export const getScopeByScopeId = (scopeId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = scopeId;
    
    if (scopeId) {
      axiosActions
        .GET(SERVER_ROUTES.SCOPE_BY_SCOPE_ID, queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException(
            "ActionsService.js - getScopeByScopeId()",
            error
          );
          reject(error);
        });
      }
      else{
        reject();
      }
    });
};

// GET LOGGED IN USER
export const getLoggedInUser = (userIdentityId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = userIdentityId;  

    axiosActions
      .GET(SERVER_ROUTES.GET_LOGGED_IN_USER, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getLoggedInUser()",
          error
        );
        reject(error);
      });
  });
};


// GMT GET FULL USER DATA
export const getUsersIdentityData = (usersIds, scopesIds, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = new GetUsersIdsEntity(usersIds, scopesIds);

    axiosActions
      .POST(SERVER_ROUTES.USERS_IDS, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getFullUserData()",
          error
        );
        reject(error);
      });
  });
};

// GMT GET ONLY RELEVANT USER DATA
export const getUsersMinimalIdentityData = (usersIds, scopesIds, selectedScope, isShowSpinner = true, closeSpinner = true) => {
  const isProjectLevel = selectedScope?.type === SCOPE_TYPE.PROJECT;
  return new Promise((resolve, reject) => {
    var requestBody = new GetUsersMinimalIdentityDataEntity(usersIds, scopesIds, isProjectLevel);

    axiosActions
      .POST(SERVER_ROUTES.USERS_MINIMAL_IDENTITY_DATA, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getUsersMinimalIdentityData()",
          error
        );
        reject(error);
      });
  });
};

// GET SELECTED USER DATA
export const getSelectedUserData = (userId, scopesIds, isShowSpinner = true, closeSpinner = true) => {  
  return new Promise((resolve, reject) => {
    var requestBody = new GetSelectedUserDataEntity(userId, scopesIds);

    axiosActions
      .POST(SERVER_ROUTES.GET_SELECTED_USER_DATA, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getSelectedUserData()",
          error
        );
        reject(error);
      });
  });
};

export const getColumnsByTableId = (tableId) => {
  return new Promise((resolve, reject) => {
    var queryParams = tableId;

    axiosActions
      .GET(SERVER_ROUTES.COLUMN, queryParams)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getColumnsByTableId()",
          error
        );
        reject(error);
      });
  });
};

export const getGmtUsers = (platformId, scopeId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?platformId=" + platformId + "&scopeId=" + scopeId;

    axiosActions
      .GET(SERVER_ROUTES.GET_GMT_USERS, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getGmtUsers()",
          error
        );
        reject(error);
      });
  });
};

export const getGmtUsersForAdmin = (platformId, scopeId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?platformId=" + platformId + "&scopeId=" + scopeId;

    axiosActions
      .GET(SERVER_ROUTES.GET_GMT_USERS_FOR_ADMIN, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getGmtUsersForAdmin()",
          error
        );
        reject(error);
      });
  });
};

export const getChargeAccountsData = (usersIds, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = new GetChargeAccountUserIdsEntity(usersIds);

    axiosActions
      .POST(SERVER_ROUTES.GET_CHARGE_ACCOUNTS, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getChargeAccountsData()",
          error
        );
        reject(error);
      });
  });
};

export const getReceipt = (invoiceSummaryIds) => {
  return new Promise((resolve, reject) => {
    var requestBody = invoiceSummaryIds;

    axiosActions
      .POST(SERVER_ROUTES.GET_RECEIPT, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - getReceipt()", error);
        reject(error);
      });
  });
};

// SIGNUP CONTROLLER FUNCTIONS
export const createUser = (createUserEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = createUserEntity;

    axiosActions
      .POST(SERVER_ROUTES.CREATE_USER, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - createUser()", error);
        reject(error);
      });
  });
};
export const registerExsistUser = (createUserEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = createUserEntity;

    axiosActions
      .POST(SERVER_ROUTES.REGISTER_EXSIST_USER, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - createUser()", error);
        reject(error);
      });
  });
};

export const registerChargeAccountUser = (registerChargeAccountEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = registerChargeAccountEntity;

    axiosActions
      .POST(SERVER_ROUTES.REGISTER_CHARGE_ACCOUNT_USER, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - registerChargeAccountUser()", error);
        reject(error);
      });
  });
};

// USER CONTROLLER FUNCTIONS
export const updateUser = (updateUserEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = updateUserEntity;

    axiosActions
      .PUT(SERVER_ROUTES.UPDATE_USER, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - updateUser()", error);
        reject(error);
      });
  });
};

export const updateChargeAccountUser = (updateChargeAccountUserEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = updateChargeAccountUserEntity;

    axiosActions
      .PUT(SERVER_ROUTES.UPDATE_CHARGE_ACCOUNT_USER, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - updateChargeAccountUser()", error);
        reject(error);
      });
  });
};

export const deleteUser = (userId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = userId;

    axiosActions
      .DELETE(SERVER_ROUTES.DELETE_USER + queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - deleteUser()", error);
        reject(error);
      });
  });
};

export const deleteChargeAccountUser = (userId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = userId;

    axiosActions
      .DELETE(SERVER_ROUTES.DELETE_CHARGE_ACCOUNT_USER + queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - deleteChargeAccountUser()", error);
        reject(error);
      });
  });
};

// VERIFICATION_CODE CONTROLLER FUNCTIONS
export const sendVerificationCode = (verificationCodeEntity) => {
  return new Promise((resolve, reject) => {
    var queryParams = "";
    var requestBody = verificationCodeEntity;

    axiosActions
      .POST(SERVER_ROUTES.SEND_VERIFICATION_CODE + queryParams, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - sendVerificationCode()",
          error
        );
        reject(error);
      });
  });
};

export const verifyCode = (verificationCodeEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = verificationCodeEntity;

    axiosActions
      .POST(SERVER_ROUTES.VERIFY_CODE, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - sendVerificationCode()",
          error
        );
        reject(error);
      });
  });
};

export const verifyOldKioskPinCode = (verificationCodeEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = verificationCodeEntity;

    axiosActions
      .POST(SERVER_ROUTES.VERIFY_KIOSK_PIN, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - verifyOldKioskPinCode()",
          error
        );
        reject(error);
      });
  });
};

export const verifyIsEmailOk = (email, userIdentityId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?email=" + email + "&userIdentityId=" + userIdentityId;

    axiosActions
      .GET(SERVER_ROUTES.VERIFY_EMAIL, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getGmtUsers()",
          error
        );
        reject(error);
      });
  });
};

export const verifyIsKioskLoginNameOk = (kioskLoginName, userId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?kioskLoginName=" + kioskLoginName + "&userId=" + userId;

    axiosActions
      .GET(SERVER_ROUTES.VERIFY_KIOSK_LOGIN_NAME, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getGmtUsers()",
          error
        );
        reject(error);
      });
  });
};

export const inviteNewGmtUser = (invitationEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = invitationEntity;

    axiosActions
      .POST(SERVER_ROUTES.INVITE_NEW_GMT, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - inviteNewGmtUser()",
          error
        );
        reject(error);
      });
  });
};

export const inviteChargeAccount = (invitationEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = invitationEntity;

    axiosActions
      .POST(SERVER_ROUTES.INVITE_CHARGE_ACCOUNT, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - inviteChargeAccount()",
          error
        );
        reject(error);
      });
  });
};

export const validatePhoneNumber = (phone, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?phoneNumber=" + phone;

    axiosActions
      .GET(SERVER_ROUTES.VALIDATE_BY_PHONE_NUMBER, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - validatePhoneNumber()",
          error
        );
        reject(error);
      });
  });
};

export const isExistUser = (userId) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?userId=" + userId;

    axiosActions
      .GET(SERVER_ROUTES.IS_USER_EXISTS + queryParams)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - isExistUser()",
          error
        );
        reject(error);
      });
  });
};

export const validateAllowedNewParkerSites = (phoneNumber, sitesIds, fromGmt, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    let requestBody = new VerificationNewParkerSitesEntity(
      phoneNumber,
      sitesIds,
      fromGmt
    );

    axiosActions
      .POST(SERVER_ROUTES.ALLOWED_NEW_PARKER_SITES, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - validateAllowedNewParkerSites()",
          error
        );
        reject(error);
      });
  });
};

export const validateIsUserExistsInUserSites = (phoneNumber, sitesIds, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    let requestBody = new VerificationIsUserExistsInUserSitesEntity(
      phoneNumber,
      sitesIds
    );

    axiosActions
      .POST(SERVER_ROUTES.IS_USER_EXISTS_IN_USER_SITES, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - validateIsUserExistsInUserSites",
          error
        );
        reject(error);
      });
  });
};

export const isFobOk = (fob, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    '?fob='+fob;
    axiosActions  
      .GET(SERVER_ROUTES.IS_FOB_OK, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - isFobOk()",
          error
        );
        reject(error);
      });
  });
};

export const getDecryptedKioskPIN = (encryptedKioskPIN, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams = '?content=' + encryptedKioskPIN;

    axiosActions  
      .GET(SERVER_ROUTES.CRYPTOGRAPHY_DECRYPT, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getDecryptedKioskPIN()",
          error
        );
        reject(error);
      });
  });
};